import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormControlComponent } from '../../../../shared/components/form-control/form-control.component';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { BaseModalComponent } from '../../../../core/layout/components/abstracts/base-modal.component';

@Component({
  selector: 'app-ticket-number-modal',
  standalone: true,
  imports: [
    FormControlComponent,
    ModalComponent,
    ReactiveFormsModule,
    TranslatePipe,
    FormsModule
  ],
  templateUrl: './ticket-number-modal.component.html',
  styleUrl: './ticket-number-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TicketNumberModalComponent extends BaseModalComponent {

  @ViewChild('ticketNrInput') ticketNrInput: ElementRef<HTMLInputElement>;

  @Output() confirm = new EventEmitter<number>();

  public ticketNr: number;

  public override open(val?: null): void {
    super.open(val);
    this.ticketNr = null;
    this.ticketNrInput.nativeElement.focus();
  }
}
